export interface ILoadingProps {
  size?: E_SIZE;
}

export enum E_SIZE {
  extraTiny = "extra-tiny",
  tiny = "tiny",
  extraSmall = "extra-small",
  small = "small",
  medium = "medium",
  large = "large",
  extraLarge = "extra-large",
  huge = "huge",
}
